import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import { hideLoader, showLoader } from '../components/loader';
import { createFormdataValues } from '../utils/createFormdataValues';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import ErrorMessage from '../components/errors/errorMessage';
import { apiUrl } from '../utils/url';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const RenameModal = ({show, setShow, endPoint, val, callAllProducts}) => {

    const [value,setValue] = useState(val);
    const { slug, basePath } = useSelector(state => state?.slugReducer);
    const [error, setError] = useState([]);
    const history = useHistory();
    const brandings = useSelector(state => state?.allBrandingReducer);

    const handleClose = () => {
        setValue(null);
        setShow(null);
    }
    const handleChange = (e) => {
        setValue({...value,[e.target.name]:e.target.value});
    }
    const handleSubmit = (e) => {
        setError([]);
        e?.preventDefault();
        var api = apiUrl + "/ProductFlow/" + endPoint;
        showLoader()
            var myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
            const formdata = createFormdataValues(value);
            formdata.append("project", slug);

            const setOptions = {
                method: "POST",
                body: formdata,
                headers: myHeaders,
            }
            fetch(api, setOptions)
            .then(async (res) => {
                const response = await res?.json();
                if (response?.status_code == 200) {
                    handleClose();
                    callAllProducts();
                    hideLoader();
                    toast.success(response?.status_message)
                }else{
                    setError(Object.values(response?.errors));
                    if (Object.keys(response?.errors).length > 0)
                        $(".modal-body").scrollTop(0);
                    hideLoader();
                }
            hideLoader();
          }).catch(() => {
            hideLoader();
          });
    }
    const handleSelectValue = (val) => {
        setValue({...value,logo:val?.logo,name:val?.brand_name,branding_id:val?.id})
    };
    const addBrand = () => {
        history.push({
            pathname:basePath + "/settings",
            state: {
                defaultPage: "branding"
            }
        });
    };
    return (
        <Modal centered show={show} onHide={handleClose} className="rename-modal">
            <div class="modal-content pt-0 pl-0 pr-0 pb-0 border-0 ">
            <div class="modal-header">
                {val?.title ?? (value?.duplicate ? 'Duplicate' : 'Rename') + 'Campaign'}
                <button type="button" class="close" onClick={handleClose} aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
                <div class="modal-body">

                    <form action="" id="" method="post" role="form" onSubmit={handleSubmit}>
                        <ErrorMessage error={error} />
                        {
                            val?.branding ? 
                            <div className="form-group">
                                {/* <label className="productlabels">
                                    Pick Brand
                                    <small className="text-red">*</small>
                                </label> */}
                                <div class="table-action-dropdown p-1 d-flex justify-content-between align-items-center gap-2 cursor-pointer zaapGlobal-input dropdown-toggle noselect dropdown-subscribers" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false" >
                                    <span className="d-flex align-items-center gap-2">
                                        <span>
                                            <img className="brand-logo" width={"22px"} height={"22px"} src={value?.logo} alt="" />
                                        </span>
                                        <span>
                                            {value?.name}
                                        </span>
                                    </span>
                                </div>
                                <ul class="dropdown-menu brand-dropdown-menu" aria-labelledby="table-action-dropdown">
                                    {brandings?.length > 0 && (
                                        brandings.map((val, idx) => (
                                            <li key={idx} onClick={() => handleSelectValue(val)}>
                                                <a class={`dropdown-item cursor-pointer border-radius-9`} >
                                                    <span><img className="brand-logo" width={"25px"} height={"25px"} src={val?.logo} alt="" /></span>
                                                    <span>{val?.brand_name} </span>
                                                </a>
                                            </li>
                                        ))
                                    )}
                                    <li onClick={() => addBrand()}>
                                        <a class={`dropdown-item cursor-pointer border-radius-9`} >
                                            <span>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                                    <rect width="22" height="22" rx="7" fill="#DBEDFF"/>
                                                    <path d="M11 6V16M6 11H16" stroke="#1188FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </span>
                                            <span>Add Brand</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            :
                        <div className='form-group'>
                            <input type="text" name="name" onChange={handleChange} className='zaapGlobal-input h-30px bg-f3f3f3' value={value?.name} />
                        </div>
                        }
                        <div className='d-flex gap-2 mt-20px align-items-center justify-content-center new-modal-footer px-0 pb-0'>
                            <button onClick={handleClose} className='fs-12 w-50 mt-0 integration-btns integration-btn-grey' type='button'>Cancel</button>
                            <button disabled={!value?.duplicate && val?.name == value?.name} className='fs-12 w-50 shadow-none  project-blue-btn' type='submit'>{value?.duplicate ? 'Duplicate' : 'Confirm'}</button>
                        </div>
                    </form>

                </div>
            </div>
        </Modal>
    )
}

export default RenameModal